module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "img-hotzone"
  }, [_c('img', {
    attrs: {
      "src": _vm.config.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "zone",
      style: ({
        width: _vm.getZoneStyle(item.widthPer),
        height: _vm.getZoneStyle(item.heightPer),
        top: _vm.getZoneStyle(item.topPer),
        left: _vm.getZoneStyle(item.leftPer)
      })
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12ce040a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12ce040a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/img_hotzone.vue
// module id = 2481
// module chunks = 0